import UAParser from "ua-parser-js";

export function isMobileDevice(userAgent) {
  const parser = new UAParser();
  parser.setUA(userAgent);
  const result = parser.getResult();
  return result.device.type === "mobile";
}
